import { query } from "./query";
export const bookConsultationQuery = {
  query,
  mocks: { defaultData: null },
};
